import {memo, useContext} from 'react'

import MatchingTitle from '../../../../../../../common/MatchingItem/MatchingItem'
import SidebarLink from '../../../../../../../common/Sidebar/SidebarLink/SidebarLink'
import {QueueSidebarSearchContext} from '../../../QueueSidebar.contexts'
import styles from '../QueueSidebarPoolItem/QueueSidebarPoolItem.css'

type Props = {
  title: string
  to: string
}

function QueueSidebarLinkItem({title, to}: Props) {
  const searchQuery = useContext(QueueSidebarSearchContext).searchQuery
  return (
    <SidebarLink to={to} className={styles.link}>
      <MatchingTitle searchQuery={searchQuery}>{title}</MatchingTitle>
    </SidebarLink>
  )
}

export default memo(QueueSidebarLinkItem)
